import { render, staticRenderFns } from "./user-unverified.vue?vue&type=template&id=07612a9b&scoped=true&"
import script from "./user-unverified.vue?vue&type=script&lang=js&"
export * from "./user-unverified.vue?vue&type=script&lang=js&"
import style0 from "./user-unverified.vue?vue&type=style&index=0&id=07612a9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07612a9b",
  null
  
)

export default component.exports